import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=06c00eab&scoped=true"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=06c00eab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c00eab",
  null
  
)

export default component.exports